import {Injectable} from '@angular/core';

class ValueItem<T extends object | number> {
    value: T;
    convertFn: (value: T) => T;
}

export type PasteFn = (o: object) => object;

@Injectable({
    providedIn: 'root'
})
export class MxCopyPasteService {

    private valueMap: Map<string, ValueItem<object | number>> = new Map();

    canPaste(classType: string): boolean {
        return !!this.valueMap.get(classType);
    }

    setData(classType: string, value?: object | number, pasteFn?: (value: object) => object): void {
        let newValue: ValueItem<object | number> = new ValueItem<object|number>();
        newValue.value = value;
        newValue.convertFn = pasteFn;
        this.valueMap.set(classType, newValue);
    }

    getData(classType: string, pasteFn?: PasteFn): number | object {
        let item = this.valueMap.get(classType);
        if (item) {
          if (typeof item.value === 'object' && pasteFn) {
                return pasteFn(item.value);
            } else {
                return item.value;
            }
        }
    }

    isFullObject(classType: string): boolean {
        return typeof this.valueMap.get(classType).value !== 'number';
    }

    getPasteFn(classType: string): (value: object) => object {
        let item = this.valueMap.get(classType);
        if (item && item.convertFn) {
            return item.convertFn as (value: object) => object;
        }
    }
}
